import type { FunctionComponent } from 'react'
import style from './PageListTitle.module.sass'

export const PageListTitle: FunctionComponent<{ children?: React.ReactNode }> = ({ children }) => {
	return <h2 className={style.wrapper}>{children}</h2>
}
